/**
 * KORA (records-request) lifecycle status pill (♻️ clone of QuestionStatusPill — records-request.md).
 * A SEPARATE component rather than widening StatusPill/QuestionStatusPill because KORAStatus
 * (KReceived/KAcknowledged/KInProgress/KFulfilled/KPartiallyFulfilled/KDenied/KClosed) is its own
 * disjoint value set, not a superset of either. Reuses the same token CSS vars by mapping each KORA
 * status onto the nearest concern token so the visual language stays one system.
 */
import { KORA_STATUS_LABELS, type KORAStatus } from "../api/types.js";

const KORA_STATUS_TOKEN: Record<KORAStatus, string> = {
  KReceived: "new",
  KAcknowledged: "acknowledged",
  KInProgress: "inprogress",
  KFulfilled: "resolved",
  KPartiallyFulfilled: "resolved",
  KDenied: "closed",
  KClosed: "closed",
};

export function KORAStatusPill({
  status,
  size = "md",
}: {
  status: KORAStatus;
  size?: "sm" | "md";
}): JSX.Element {
  const token = KORA_STATUS_TOKEN[status];
  return (
    <span
      className={`td-pill td-pill--${size}`}
      style={{
        color: `var(--td-status-${token}-fg)`,
        background: `var(--td-status-${token}-bg)`,
      }}
    >
      <span
        className="td-pill__dot"
        style={{ background: `var(--td-status-${token}-dot)` }}
        aria-hidden="true"
      />
      {KORA_STATUS_LABELS[status]}
    </span>
  );
}
